export const WWW_SITE_URL = process.env.WWW_SITE_URL;
export const API_URL = process.env.API_URL;

export const STATIC_URL = process.env.STATIC_URL;
export const APP_ENV = process.env.APP_ENV;
export const HOT_JAR_ID = process.env.HOT_JAR_ID;
export const MIX_PANEL_ID = process.env.MIX_PANEL_ID;

// OAuth 공통 인증 도메인
export const OAUTH_AUTH_DOMAIN = process.env.OAUTH_AUTH_DOMAIN || 'https://auth.finance.cloud';
